export default __webpack_public_path__ + "static/media/e1337.ddb8cadc.svg";